




































































































































































import { BreadCrumb } from "@/store/modules/GlobalStore";
import { Component } from "vue-property-decorator";
import BasePage from "../base/BasePage";
import { AccountService } from "@/services/AccountService";
import { LoginModel } from "@/models/LoginModel";
import { Routes } from "@/router/Routes";
import { accountStore } from "@/store/modules/AccountStore";
import { NullableString } from "@/code/Types";

@Component
export default class extends BasePage {
  title = " ";
  breadCrumbs = [new BreadCrumb("/")];

  accountService = new AccountService();

  email: NullableString = null;
  otp: NullableString = null;
  sentOtp = false;
  loginError = false;
  otpEmail: NullableString = null;
  isProcessRunning = false;

  created(): void {
    const query = this.$route.query;
    if (query) {
      if (query.email) {
        this.email = query.email.toString();
      }
      if (query.otp) {
        this.sentOtp = query.otp === "true" ? true : false;
      }
    }
  }

  async validateLoginForm(): Promise<void> {
    if (this.isFormValid) {
      if (this.otp == null) {
        await this.sendOtp();
      } else {
        await this.login();
      }
    }
  }

  async sendOtp(): Promise<void> {
    if (this.email?.trim() !== "") {
      if (this.email) {
        this.otp = "";
        this.sentOtp = await this.accountService.sendOtp(this.email);
        if (!this.sentOtp) {
          this.loginError = true;
        } else {
          this.otpEmail = this.email;
        }
      }
    }
  }

  async login(): Promise<void> {
    if (this.otp?.trim() !== "") {
      if (this.otp !== "") {
        this.isProcessRunning = true;
        this.loginError = false;
        const credentials = new LoginModel();
        credentials.email = this.email;
        credentials.otp = this.otp;
        await accountStore.login(credentials);
        if (accountStore.isLoggedIn) {
          await this.$router.push({ name: Routes.POSTLOGIN_LANDINGPAGE });
        } else {
          this.loginError = true;
        }
        this.isProcessRunning = false;
      }
    }
  }

  get supportEmail(): string {
    return "support@thepalladiumgrp.com";
  }
  onBackButtonClick(): void {
    this.sentOtp = false;
    this.loginError = false;
    this.email = null;
    this.otp = null;
  }
}
